export default __webpack_public_path__ + "assets/pressure-high.80df05ed.svg";